/** User-facing training hierarchy: Program > Module > Lesson > Quiz */
export const TRAINING = {
  program: "Program",
  programs: "Programs",
  module: "Module",
  modules: "Modules",
  lesson: "Lesson",
  lessons: "Lessons",
  quiz: "Quiz",
};

/** API/DB titles may still end with "Academy"; normalize for display. */
export function displayProgramTitle(title) {
  if (!title) return TRAINING.program;
  return title.replace(/\sAcademy$/i, ` ${TRAINING.program}`);
}

/** Header breadcrumb: Program · Module while inside a module or lesson. */
export function buildModuleHeaderContext(module, academySlug) {
  if (!module) return null;
  return {
    programTitle: displayProgramTitle(module.academy_title),
    programSlug: module.academy_slug || academySlug,
    moduleTitle: module.title,
  };
}

const ACADEMY_BASE = "/academy";

/** Breadcrumb trail: Programs > Program > Module > current page. */
export function buildAcademyBreadcrumbs({
  programTitle,
  programSlug,
  moduleTitle,
  moduleSlug,
  currentLabel,
} = {}) {
  const items = [{ label: TRAINING.programs, to: ACADEMY_BASE }];

  if (programTitle && programSlug) {
    items.push({
      label: programTitle,
      to: moduleTitle || currentLabel ? `${ACADEMY_BASE}/${programSlug}` : undefined,
    });
  }

  if (moduleTitle) {
    items.push({
      label: moduleTitle,
      to:
        currentLabel && moduleSlug && programSlug
          ? `${ACADEMY_BASE}/${programSlug}/module/${moduleSlug}`
          : undefined,
    });
  }

  if (currentLabel) {
    items.push({ label: currentLabel });
  }

  return items;
}
